
import { mapState } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import ProductSlideShow from '../../components/product/SildeShow'
import SingleProductElement from '../../components/product/single'
import LastSeen from '../../components/home/LastSeen'
import RelatedCollection from '../../components/collection/RelatedCollection.vue'
// import ShopCounselor from '../../components/shop/ShopCounselor.vue'
import ExpandContact from '../../components/contact/ExpandContact.vue'
import { CHAT_SET_CHAT_WITH_SHOP } from '../../store/store.const'
import { removeVietnameseTones, textToSlug, handleKeyDownQuantity } from '../../utils/utils'
import {
  INDEX_SET_SUCCESS,
  INDEX_SET_HIDE_FOOTER,
  PRODUCT_DETAIL,
  PRODUCT_COMMENT,
  PRODUCT_COMMENT_IMAGE,
  PRODUCT_FAVORITE,
  PRODUCT_RELATED,
  CART_ADD_CART,
  AUTH_OPEN_MODAL_LOGIN,
  AUTH_SET_RESET_CART,
  QUICK_ORDER_CREATE_ORDER,
  PRODUCT_SOCIAL_POSTS,
  PRODUCT_SOCIAL_POST_CLICK,
  MASTER_GET_DATA,
  PRODUCT_RECOMMENDED_BY_CATEGORY
} from '@/store/store.const'

export default {
  name: 'DetailProductPage',
  components: {
    ProductSlideShow,
    SingleProductElement,
    LastSeen,
    VueSlickCarousel,
    RelatedCollection,
    // ShopCounselor,
    ExpandContact
  },
  layout: 'default-details',
  async asyncData({ app, store, route, redirect }) {
    let res = {}
    try {
      res = await store.dispatch(PRODUCT_DETAIL, { id: route.params.id.split('.')[1], slug: route.params.id.split('.')[0] }) // fetchDataProduct
    } catch (e) {
      console.error(e)
      redirect(301, '/')
    }
    if (res.data) {
      const product = res.data.product
      const staffs = res.data.staffs
      const conditionalData = {}
      if (product.productTypes.length) {
        const selectedProductType = product.productTypes[0]
        conditionalData.selectedProductType = selectedProductType
        conditionalData.price = selectedProductType.price_format
        conditionalData.realPrice = selectedProductType?.promotional_price ? selectedProductType.real_price_format : 0
        if (selectedProductType.product_classification_main_item) {
          if (selectedProductType.product_classification_main_item.full_product_image_url) {
            conditionalData.image = selectedProductType.product_classification_main_item.full_product_image_url
          }
        }
      }
      if (product.rate_count) {
        conditionalData.totalRate = (product.productInformation.one_star_count +
          product.productInformation.two_star_count * 2 +
          product.productInformation.three_star_count * 3 +
          product.productInformation.four_star_count * 4 +
          (product.productInformation.five_star_count + (product.productInformation.six_star_count || 0)) * 5) / product.rate_count
        conditionalData.totalRate = conditionalData.totalRate.toFixed(1)
        conditionalData.isHaveComment = true
      }
      const scripts = {}
      if (product.meta_pixel) {
        const parent = document.createElement('div')
        parent.innerHTML = product.meta_pixel

        parent.childNodes.forEach(child => {
          let tag = child.tagName
          if (tag === undefined) return
          tag = tag.toLowerCase()

          if (scripts[tag] === undefined) scripts[tag] = []
          scripts[tag].push({
            innerHTML: child.innerHTML
          })
        })
      }
      const defaultTtile = product.name + '_' + app.i18n.t('home.title')
      scripts.title = product?.meta_title ?? defaultTtile
      scripts.meta = [
        { hid: 'title', name: 'title', content: product?.meta_title ?? defaultTtile },
        { hid: 'description', name: 'description', content: product.meta_description ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'website' },
        { hid: 'twitter:title', name: 'twitter:title', content: product?.meta_title ?? defaultTtile },
        { hid: 'twitter:description', name: 'twitter:description', content: product.meta_description ?? '' },
        { hid: 'twitter:image', name: 'twitter:image', content: product.meta_image ?? '' },
        { hid: 'twitter:keywords', name: 'twitter:keywords', content: product.meta_keywords ?? '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: product?.meta_title ?? defaultTtile },
        { hid: 'og:description', property: 'og:description', content: product.meta_description ?? '' },
        { hid: 'og:image', property: 'og:image', content: product.meta_image ?? '' },
        { hid: 'og:keywords', property: 'og:keywords', content: product.meta_keywords ?? '' },
        { hid: 'robots', name: 'robots', content: product.meta_robots ?? '' }
      ]
      if (product.canonical !== null) {
        scripts.link = [
          { hid: 'canonical', rel: 'canonical', href: product.canonical }
        ]
      }
      return {
        product,
        staffs,
        shop: product.shop,
        categories: res.data.categories,
        image: product.productTypes[0]
          ? product.productTypes[0].product_classification_main_item && product.productTypes[0].product_classification_main_item.full_product_image_url
            ? product.productTypes[0].product_classification_main_item.full_product_image_url
            : product.productTypes[0].product_image_url
              ? product.productTypes[0].product_image_url
              : product.default_image
          : product.default_image,
        isLiked: res.data.isLiked,
        price: product.price,
        scripts,
        shop_active_products: product.shop_active_products,
        realPrice: parseFloat(product.promotional_price) ? product.real_price : 0,
        ...conditionalData
      }
    }
    redirect(301, '/')
  },
  data() {
    const dataId = this.$route.params.id.split('.')
    return {
      avatar: '/assets/images/icons/avatar-mac-dinh.svg',
      id: dataId[1],
      isLiked: false,
      scripts: {},
      totalRate: 0,
      isShowPhone: false,
      paginationComment: {
        count: 0,
        current_page: 0,
        per_page: 0,
        total: 0,
        total_pages: 0
      },
      image: '',
      listSlide: [],
      totalImage: 10,
      quantity: 1,
      price: 0,
      realPrice: 0,
      evaluatePage: 1,
      isHaveComment: false,
      commentFilter: 'all',
      selectedProductType: {},
      tabShow: 'detail',
      comments: [],
      socialPosts: [],
      isShowNote: false,
      product: {
        id: 1,
        name: '',
        description: '',
        default_image: '',
        sku_code: '',
        price: 0,
        promotional_price: 0,
        shop_active_products: 0,
        real_price: 0,
        ship_price: 0,
        ship_information: '',
        view_count: 100,
        like_count: 100,
        order_count: 100,
        rate_count: 5,
        is_free_shipping: 1,
        shop: {
          id: 1,
          name: '',
          logo_url: 'images.jpg',
          phone: '0987654321',
          product_count: 100,
          user_follow: 100,
          rate_point: 0,
          rate_total: 0,
          response_rate: 0
        },
        productImages: [],
        productPropertiesItems: [],
        productInformation: {
          id: 1,
          product_id: 1,
          one_star_count: 1,
          two_star_count: 2,
          three_star_count: 3,
          four_star_count: 4,
          five_star_count: 5,
          six_star_count: 6,
          attach_count: 8,
          comment_count: 7
        },
        productClassificationMain: [
          {
            id: 1,
            product_id: 1,
            name: 'Màu sắc'
          }
        ],
        product_tags: [],
        productTypes: []
      },
      relatedProducts: [],
      shop: {
        id: 1,
        name: '',
        logo_url: '',
        phone: '',
        product_count: 0,
        user_follow: 0,
        rate_point: 0,
        rate_total: 0,
        response_rate: 0
      },
      categories: [],
      slideSetting: {
        'dots': false,
        'swipeToSlide': true,
        'focusOnSelect': true,
        'infinite': true,
        'speed': 500,
        'slidesToShow': 5,
        'touchThreshold': 5,
        'responsive': [
          {
            'breakpoint': 768,
            'settings': {
              'slidesToShow': 5,
              'swipe': true,
              'focusOnSelect': true
            }
          },
          {
            'breakpoint': 520,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 1,
              'swipeToSlide': true,
              'focusOnSelect': true,
              'variableWidth': true
            }
          }
        ]
      },
      imageIndex: 0,
      imageTouchX: 0,
      imagePreviewDialog: false,
      dialogImageIndex: 0,
      isExpandedDetail: false,
      isExpandedVote: false,
      showStickyBuyBar: false,
      galleryMode: 'list',
      showTooltip: false,
      isTooltipClosed: false,
      tooltipTimer: null,
      showDetailMoreButton: false,
      showVoteMoreButton: false,
      showRecommendedBlock: false,
      recommendedCategories: [],
      recommendedProducts: [],
      selectedCategoryId: null,
      loadingRecommended: false,
      hasFetchedRecommendedCategories: false,
      isVideoClosed: false,
      descriptionPreviewDialog: false
    }
  },
  head() {
    return this.scripts
  },
  computed: {
    ...mapState({
      setting: state => state.setting
    }),
    currentImageIndex() {
      if (!this.product || !this.product.productImages || this.product.productImages.length === 0) return 1
      const index = this.product.productImages.findIndex(img => img.full_url === this.image)
      return index !== -1 ? index + 1 : 1
    },
    ...mapState('authentication', {
      openModalLoginState: state => state.openModalLoginState,
      resetCartState: state => state.resetCartState
    }),
    metaPixelScripts() {
      const scripts = {}
      if (!process.browser) return scripts
      if (this.product.meta_pixel) {
        const parent = document.createElement('div')
        parent.innerHTML = this.product.meta_pixel

        parent.childNodes.forEach(child => {
          let tag = child.tagName
          if (tag === undefined) return
          tag = tag.toLowerCase()

          if (scripts[tag] === undefined) scripts[tag] = []
          scripts[tag].push({
            innerHTML: child.innerHTML
          })
        })
      }
      const defaultTitle = this.product.name + ' - ' + this.$t('home.title')
      scripts.title = this.product?.meta_title ?? defaultTitle
      scripts.meta = [
        { hid: 'title', name: 'title', content: this.product?.meta_title ?? defaultTitle },
        { hid: 'description', name: 'description', content: this.product.meta_description ?? '' },
        { hid: 'twitter:card', name: 'twitter:card', content: 'website' },
        { hid: 'twitter:title', name: 'twitter:title', content: this.product?.meta_title ?? defaultTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: this.product.meta_description ?? '' },
        { hid: 'twitter:image', name: 'twitter:image', content: this.product.meta_image ?? '' },
        { hid: 'twitter:keywords', name: 'twitter:keywords', content: this.product.meta_keywords ?? '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:title', property: 'og:title', content: this.product?.meta_title ?? defaultTitle },
        { hid: 'og:description', property: 'og:description', content: this.product.meta_description ?? '' },
        { hid: 'og:image', property: 'og:image', content: this.product.meta_image ?? '' },
        { hid: 'og:keywords', property: 'og:keywords', content: this.product.meta_keywords ?? '' },
        { hid: 'robots', name: 'robots', content: this.product.meta_robots ?? '' }
      ]
      return scripts
    },
    videoUrl() {
      if (!this.product?.description_video) return ''
      let url = this.product.description_video
      // Handle YouTube URLs to ensure they are embed format and have autoplay/mute
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        // If it's a watch URL, convert to embed
        if (url.includes('watch?v=')) {
          url = url.replace('watch?v=', 'embed/')
        }
        const separator = url.includes('?') ? '&' : '?'
        // Autoplay needs mute=1 in most browsers to work automatically
        if (!url.includes('autoplay=')) {
          url += `${separator}autoplay=1&mute=1&rel=0`
        }
      }
      return url
    },
    processedDescription() {
      if (!this.product || !this.product.description) return ''
      let desc = this.product.description
      const iframeRegex = /<iframe[^>]*src="[^"]*(youtube\.com|youtu\.be)[^"]*"[^>]*>/gi
      desc = desc.replace(iframeRegex, (match) => {
        if (match.includes('sandbox=')) {
          return match.replace(/sandbox="[^"]*"/gi, 'sandbox="allow-scripts allow-same-origin allow-presentation allow-forms"')
        } else {
          return match.replace('<iframe', '<iframe sandbox="allow-scripts allow-same-origin allow-presentation allow-forms"')
        }
      })
      return desc
    }
  },
  watch: {
    selectedProductType() {
      if (this.selectedProductType.product_classification_main_item) {
        if (this.selectedProductType.product_classification_main_item.full_product_image_url) {
          this.image = this.selectedProductType.product_classification_main_item.full_product_image_url
        }
      } else {
        this.image = this.selectedProductType.product_image_url ? this.selectedProductType.product_image_url : this.image
      }
      this.price = this.selectedProductType.price_format
      this.realPrice = this.selectedProductType.promotional_price ? this.selectedProductType.real_price_format : 0
    },
    'product.id'() {
      this.isVideoClosed = false
    },
    quantity() {
      if (!this.quantity) {
        this.quantity = 1
      }
    },
    image(newVal) {
      if (this.$device.isMobile) {
        this.$nextTick(() => {
          this.scrollThumbnailIntoView()
        })
      }
    }
  },
  created() {
    this.fetchComments()
    this.fetchImage()
    this.related()
    this.fetchSocialPosts()
  },
  mounted() {
    this.$store.commit(INDEX_SET_HIDE_FOOTER, true)
    window.addEventListener('scroll', this.handleScroll)
    // Initial check in case page is loaded/reloaded at a scrolled position
    this.$nextTick(() => {
      this.handleScroll()
    })
    this.$gtm.push({
      event: 'view_item',
      ecommerce: {
        items: [
          {
            id: this.product.id,
            name: this.product.name,
            price: Number(this.product.price.replace(/\./g, '')),
            google_business_vertical: 'retail'
          }
        ]
      }
    })
    this.$nextTick(() => {
      this.checkExpansion()
    })
  },
  beforeDestroy() {
    this.$store.commit(INDEX_SET_HIDE_FOOTER, false)
    window.removeEventListener('scroll', this.handleScroll)
    if (this.tooltipTimer) {
      clearTimeout(this.tooltipTimer)
    }
  },
  methods: {
    async chatWithShop() {
      if (this.$auth.loggedIn) {
        await this.$store.commit(CHAT_SET_CHAT_WITH_SHOP, this.shop)
      } else {
        await this.$store.commit(AUTH_OPEN_MODAL_LOGIN, !this.openModalLoginState)
      }
    },
    async fetchSocialPosts() {
      try {
        const res = await this.$store.dispatch(PRODUCT_SOCIAL_POSTS, { id: this.product.id, limit: 6 })
        if (res.data) {
          this.socialPosts = res.data.data || res.data
        }
      } catch (e) {
        console.error(e)
      }
    },
    async handleSocialPostClick(post) {
      if (post.link) {
        window.open(post.link, '_blank')
      }
      try {
        await this.$store.dispatch(PRODUCT_SOCIAL_POST_CLICK, { socialPostId: post.id })
      } catch (e) {
        console.error(e)
      }
    },
    async fetchComments() {
      const res = await this.$store.dispatch(PRODUCT_COMMENT, { id: this.id })
      if (res.data) {
        this.comments = res.data.data
        this.paginationComment.per_page = res.data.pagination.per_page
        this.paginationComment.total = res.data.pagination.total
        this.paginationComment.count = res.data.pagination.count
        this.paginationComment.total_pages = res.data.pagination.total_pages
        this.$nextTick(() => {
          this.checkExpansion()
        })
      }
    },
    async fetchImage() {
      const res = await this.$store.dispatch(PRODUCT_COMMENT_IMAGE, { id: this.id })
      if (res.data) {
        this.listSlide = res.data.data
        this.paginationComment = res.data.pagination
      }
    },
    async like() {
      const res = await this.$store.dispatch(PRODUCT_FAVORITE, { id: this.id, status: !this.isLiked })
      if (res.data) {
        this.isLiked = !this.isLiked
        await this.$store.commit(INDEX_SET_SUCCESS, {
          show: true,
          text: res.message
        })
      } else {
        await this.$store.commit(AUTH_OPEN_MODAL_LOGIN, !this.openModalLoginState)
      }
    },
    async related() {
      const res = await this.$store.dispatch(PRODUCT_RELATED, { id: this.id })
      if (res.data?.length) {
        this.relatedProducts = res.data
      }
    },
    async addCart(redirect = false) {
      const param = {
        product_id: this.id,
        quantity: this.quantity
      }
      param.product_type_id = this.selectedProductType.id ?? 0

      if (!this.$auth.loggedIn && redirect === true) {
        const res = await this.$store.dispatch(QUICK_ORDER_CREATE_ORDER, param)
        if (res.status_code === 200) {
          this.$router.push('/checkout/' + res.data.group_code)
        } else {
          this.$message.error(res.data.product[0])
        }
        return
      }

      const res = await this.$store.dispatch(CART_ADD_CART, param)
      if (res.data) {
        if (res.status_code === 200) {
          await this.$store.commit(INDEX_SET_SUCCESS, {
            show: true,
            text: this.$t('message.add_cart_success')
          })
          await this.$store.commit(AUTH_SET_RESET_CART, !this.resetCartState)
          if (redirect === true) {
            await this.$router.push({ name: 'cart', params: { id: this.id }})
          }
          this.$gtm.push({
            event: 'addToCart',
            ecommerce: {
              add: {
                products: [{
                  id: this.product.id,
                  name: this.product.name,
                  price: Number(this.product.price.replace(/\./g, '')),
                  quantity: this.quantity,
                  google_business_vertical: 'retail'
                }]
              }
            }
          })
        } else {
          this.$message.error(res.data.product[0])
        }
      } else {
        await this.$store.commit(AUTH_OPEN_MODAL_LOGIN, !this.openModalLoginState)
      }
    },
    async filterComment(type) {
      if (type) { // change type, else just change page
        this.commentFilter = type
        this.evaluatePage = 1
      }
      const param = {
        id: this.id,
        page: this.evaluatePage
      }
      switch (this.commentFilter) {
        case 'new':
          param.order_by = 'desc'
          break
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
          param.rate_star = this.commentFilter
          break
        case 'has_comment':
          param.has_comment = true
          break
        case 'has_image':
          param.has_image = true
          break
      }
      const res = await this.$store.dispatch(PRODUCT_COMMENT, param)
      if (res.data) {
        this.comments = res.data.data
        this.paginationComment.per_page = res.data.pagination.per_page
        this.paginationComment.total = res.data.pagination.total
        this.paginationComment.count = res.data.pagination.count
        this.paginationComment.total_pages = res.data.pagination.total_pages
        this.$nextTick(() => {
          this.checkExpansion()
        })
      }
    },
    checkExpansion() {
      const threshold = 480 // Original max-height threshold in CSS
      if (this.$refs.detailContent) {
        this.showDetailMoreButton = this.$refs.detailContent.scrollHeight > threshold
      }
      if (this.$refs.voteContent) {
        this.showVoteMoreButton = this.$refs.voteContent.scrollHeight > threshold
      }
    },
    async handleCurrentAvaluate(val) {
      this.evaluatePage = val
      await this.filterComment()
    },
    changeImage(event, type) {
      let touchLength = 0
      switch (type) {
        case 0:
          this.imageTouchX = event.clientX
          break
        case 1:
          touchLength = event.clientX - this.imageTouchX
          break
        case 2:
          this.imageTouchX = event.changedTouches[0].clientX
          break
        case 3:
          touchLength = event.changedTouches[0].clientX - this.imageTouchX
          break
      }
      if (touchLength === 0) return
      if (touchLength > 100) {
        this.prevImage()
      } else if (touchLength < -100) {
        this.nextImage()
      }
    },
    nextImage() {
      this.imageIndex = ++this.imageIndex % this.product.productImages.length
      this.image = this.product.productImages[this.imageIndex].full_url
    },
    prevImage() {
      this.imageIndex = (this.imageIndex - 1 + this.product.productImages.length) % this.product.productImages.length
      this.image = this.product.productImages[this.imageIndex].full_url
    },
    scrollThumbnailIntoView() {
      const wrapper = this.$el.querySelector('.thumbnail-carousel-wrapper')
      if (!wrapper) return
      const activeEl = wrapper.querySelector('.active-thumbnail')
      if (!activeEl) return
      activeEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
    },
    handleTagClick(tag) {
      if (!this.product.productImages) return
      const url = tag.image_url || tag.full_url || tag.image || tag.full_image_url
      if (url) {
        const index = this.product.productImages.findIndex(img => img.full_url === url || img.image_url === url || img.full_image_url === url)
        if (index !== -1) {
          this.imageIndex = index
          this.image = this.product.productImages[index].full_url
          if (this.$refs.carouselDetail) {
            this.$refs.carouselDetail.goTo(index)
          }
        }
      }
    },
    openGallery(mode, index) {
      this.galleryMode = mode
      this.imagePreviewDialog = true
      if (mode === 'list' && index !== undefined) {
        this.$nextTick(() => {
          this.scrollToImage(index)
        })
      }
    },
    openDescriptionPreview() {
      this.descriptionPreviewDialog = true
    },
    scrollToImage(index) {
      const refName = 'gallery-img-' + index
      const el = this.$refs[refName]
      if (el && el[0]) {
        el[0].scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    showSold(val) {
      let sold = Number(val)
      if (sold > 1000) {
        sold = (sold / 1000).toFixed(1) + 'k'
        sold = sold.replace('.0', '')
        sold = sold.replace('.', ',')
      }
      return sold
    },
    slugData(name) {
      return textToSlug(removeVietnameseTones(name))
    },
    showNote() {
      this.isShowNote = !this.isShowNote
    },
    handleKeyDown(event) {
      handleKeyDownQuantity(event)
    },
    collapseDetail() {
      this.isExpandedDetail = false
      this.$nextTick(() => {
        const el = document.getElementById('detail-anchor')
        if (el) {
          const yOffset = -20
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    },
    collapseVote() {
      this.isExpandedVote = false
      this.$nextTick(() => {
        const el = document.getElementById('vote-anchor')
        if (el) {
          const yOffset = -20
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    },
    closeTooltip() {
      this.showTooltip = false
      this.isTooltipClosed = true
    },
    handleScroll() {
      const el = document.getElementById('main-buy-button')
      if (el) {
        const rect = el.getBoundingClientRect()
        const wasSticky = this.showStickyBuyBar
        // Only show sticky bar when original button is scrolled out (rect.top < 0)
        this.showStickyBuyBar = rect.bottom < 0

        // Lazy load Recommended Products block on mobile
        if (this.$device.isMobile && !this.showRecommendedBlock) {
          if (rect.top <= 0) {
            this.showRecommendedBlock = true
            this.fetchRecommendedCategories()
          }
        }

        // Auto show and timer for tooltip when sticky bar appears
        if (this.showStickyBuyBar && !wasSticky && !this.isTooltipClosed && this.product.total_week_sold > 0) {
          this.showTooltip = true
          if (this.tooltipTimer) clearTimeout(this.tooltipTimer)
          this.tooltipTimer = setTimeout(() => {
            this.showTooltip = false
            this.isTooltipClosed = true
          }, 8000)

          // Store the scroll position when tooltip appeared to check for "scrolled too far"
          this.displayedScrollY = window.pageYOffset
        }

        // Hide tooltip if it's no longer sticky (user scrolled back up)
        if (!this.showStickyBuyBar) {
          this.showTooltip = false
        }

        // Auto hide if scroll significantly down from where it appeared (e.g. +1000px)
        // or if we reached the very bottom of the page
        const scrollBottom = window.innerHeight + window.pageYOffset
        const docHeight = document.documentElement.offsetHeight
        const isNearBottom = docHeight - scrollBottom < 100

        if (this.showTooltip) {
          const scrolledFarDown = this.displayedScrollY && (window.pageYOffset > this.displayedScrollY + 1000)
          if (scrolledFarDown || isNearBottom) {
            this.showTooltip = false
            this.isTooltipClosed = true
          }
        }
      }
    },
    async fetchRecommendedCategories() {
      if (this.hasFetchedRecommendedCategories) return
      try {
        console.log('Fetching recommended categories for product ID:', this.id)
        const params = {
          'resources[recommended_categories]': `{"product_id": ${this.id}}`
        }
        const queryString = new URLSearchParams(params).toString()
        const res = await this.$store.dispatch(MASTER_GET_DATA, queryString)
        if (res.data && res.data.recommended_categories) {
          this.recommendedCategories = res.data.recommended_categories
          this.hasFetchedRecommendedCategories = true
          if (this.recommendedCategories.length > 0) {
            this.selectRecommendedCategory(this.recommendedCategories[0].id)
          }
        }
      } catch (e) {
        console.error('Error fetching recommended categories:', e)
      }
    },
    async selectRecommendedCategory(categoryId) {
      this.selectedCategoryId = categoryId
      this.loadingRecommended = true
      try {
        const res = await this.$store.dispatch(PRODUCT_RECOMMENDED_BY_CATEGORY, {
          category_id: categoryId,
          limit: 12
        })
        if (res.data) {
          this.recommendedProducts = res.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingRecommended = false
      }
    }
  }
}
